/**
 * 懒加载组件
 * addHtml 方法，是给需要做特殊处理的结构使用的，在继承的类中重新这个方法就可以了。
 * 
 * 使用结构
 * <le-lazy-tool>
        <div class="ld-scroll-load-mode" type="sayingSection"></div>
    </le-lazy-tool>

    type: 是为了让在重写addHtml方法时，知道是哪个结构需要添加html
 */
class LeLazyTool extends HTMLElement {
  constructor() {
    super();

    this.lazyHtmls = null
    this.lazyNodes = null

    this.init()
  }

  init() {
    this.lazyNodes = $.map($(this).find('.ld-scroll-load-mode').get(), function (i) { return $(i); })

    this.onScrollHandler = this.customThrottle(this.onScroll.bind(this), 200);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScroll()
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    if (this.lazyNodes && this.lazyNodes.length > 0) {
      var loadedIndex = []
      this.lazyNodes.forEach((node, index) => {
        if (this.isInViewport(node)) {
          var type = node.attr('type')
          if (type) {
            if (this.lazyHtmls) {
              var dataHtml = this.lazyHtmls[type]
              if (dataHtml) {
                node.append(dataHtml)
              }
            }
          }
          node.addClass('ld-scroll-load-show')
          node.css({ height: 'initial' })

          this.addHtml(type)

          loadedIndex.unshift(index);
        }
      })
      loadedIndex.forEach((index) => {
        this.lazyNodes.splice(index, 1)
      })
    }
  }

  addHtml(type) { }

  isInViewport($el) {
    const elementTop = $el.offset().top
    const elementBottom = elementTop + $el.outerHeight()
    const viewportTop = $(window).scrollTop()
    const viewportBottom = viewportTop + $(window).height()

    return elementBottom > viewportTop && elementTop < viewportBottom
  }

  customThrottle(fn, delay) {
    var last = 0
    return function () {
      var now = Date.now()
      if (now - last >= delay) {
        last = now
        fn.apply(this, arguments)
      }
    }
  }
}
customElements.define('le-lazy-tool', LeLazyTool);

/**
 * 添加购物车按钮组件
 * 下面是使用方法，必须要包括下面结构
 * <le-add-cart-btn>
        <button data-id="{{ variantProduct.id }}" data-coupon="{{ variantsDiscounts.product_detail_max_discount.code }}" class="add-to-btn cursor-pointer btn-animation flex align-items-center">
            xxx
            <span class="btn-label buy-now">Buy Now</span>
        </button>
    </le-add-cart-btn>

    data-id 是变体id(必须)
    data-coupon 是变体所拥有的折扣码(不是必须)
    <span class="btn-label buy-now">Buy Now</span> 加购后跳转到支付页面

    xxx 是自定义的内容
 */
class LeAddCartBtn extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')

    this.batch = this.dataset.batch // 是否是批量加购

    this.init()
  }

  init() {
    this.bindEvent()
  }

  bindEvent() {
    const buttonNode = this.querySelectorAll('button')
    buttonNode.forEach(item => {
      if (this.batch) {
        item.addEventListener('click', this.clickHandlerBatch.bind(this))
      } else {
        item.addEventListener('click', this.clickHandler.bind(this))
      }
    })
  }

  // 单个商品加购
  clickHandler(e) {
    this.callbackClick(e)

    const buttonNode = e.currentTarget

    if (!buttonNode) {
      window.location = window.routes.cart_url
      return
    }
    const id = buttonNode.dataset.id

    const hasClass = (Boolean(e.target.closest?.('.buy-now')) || e.target.classList.contains('buy-now') || Boolean(e.currentTarget.matches?.('.checkout-btn')))
    // 判断是否打开商品详情弹窗
    if (this.isOpenProductDialog() && !hasClass) {
      this.openProductDialog(id)
      return
    }
  
    const quantity = buttonNode.dataset.quantity || 1
    buttonNode.classList.add('loading')
    buttonNode.setAttribute('disabled', true)

    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    const formData = new FormData()
    formData.append('id', id)
    formData.append('quantity', quantity)

    config.body = formData

    if (this.cart) {
      config.body.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      config.body.append('sections_url', window.location.pathname)
    }

    this.addCartRequest(e, config)
  }

  // 批量加购
  clickHandlerBatch(e) {
    this.callbackClick(e)

    const buttonNode = e.currentTarget

    const productItems = []
    const dataProducts = this.dataset.products
    if (dataProducts) {
      productItems.push(...JSON.parse(dataProducts))
    }

    if (!productItems.length) {
      return
    }
    buttonNode.classList.add('loading')
    buttonNode.setAttribute('disabled', true)

    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'

    const formData = {
      'items': productItems
    }

    if (this.cart) {
      formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
      formData['sections_url'] = window.location.pathname
    }

    config.body = JSON.stringify(formData)

    this.addCartRequest(e, config)
  }

  /** 使用 折扣码 */
  async setDiscountCode(buttonNode = this.querySelector('button')) {
    let coupon = buttonNode?.dataset.coupon || '';
    if (this.batch && this.dataset.coupons) {
      coupon = JSON.parse(this.dataset.coupons).map(item => item.coupon).filter(Boolean).join(',');
    }
    await window.ShopifyConstant.applyCartDiscountCodes([coupon]);
  }

  // Add the item before applying its product coupon.
  addCartRequest(e, config) {
    let discountFailed = false
    const hasClass = (Boolean(e.target.closest?.('.buy-now')) || e.target.classList.contains('buy-now') || Boolean(e.currentTarget.matches?.('.checkout-btn'))) // 存在这个类说明加购成功后跳转到支付页面
    const buttonNode = e.currentTarget
    const checkoutDirect = hasClass && buttonNode.dataset.checkoutDirect === 'true'
    return fetch(`${routes.cart_add_url}`, config)
      .then(async (response) => {
        const cartData = await response.json()
        if (checkoutDirect && !response.ok) throw new Error(cartData.message || 'Unable to add item to cart')
        if (!response.ok || cartData.status) return cartData
        // Activity Buy Now applies its coupon through Shopify's native checkout redirect.
        if (checkoutDirect) return cartData
        try {
          await this.setDiscountCode(buttonNode)
        } catch (error) {
          discountFailed = true
          window.ShopifyConstant.reportCartDiscountError(error)
        }
        return cartData
      })
      .then((response) => {
        if (response.status) {
          if (response.message) {
            window.ShopifyConstant.messageTip(response.message, 'error')
          }
          return
        }
        if (checkoutDirect) {
          const coupon = window.isB2BCustomer ? '' : (buttonNode.dataset.coupon || '').trim()
          window.location = coupon ? `/discount/${encodeURIComponent(coupon)}?redirect=%2Fcheckout` : '/checkout'
          return
        }
        if (!this.cart) {
          window.location = window.routes.cart_url
          return
        }
        if (hasClass && !discountFailed) {
          window.location = '/checkout'
          return
        }

        this.ajaxSuccess()
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart.renderContents(response)
        })
      })
      .catch((e) => {
        if (e.message) {
          window.ShopifyConstant.messageTip(e.message, 'error')
        }
      })
      .finally((e) => {
        buttonNode.removeAttribute('disabled')
        buttonNode.classList.remove('loading')
      })
  }

  // 判断是否是打开商品详情弹窗
  isOpenProductDialog() {
    return this.dataset.productDialog
  }
  // 点击加购按钮打开商品详情弹窗(只做了单个产品)
  openProductDialog(id) {
    window.ShopifyConstant.setProductDialog(this.isOpenProductDialog(), id, this.dataset.productDialogTheme)
  }

  /** 点击的回调 */
  callbackClick(e) { }

  // 加购成功回调
  ajaxSuccess() {
    this.callbackSuccess()
    this.closeProductDialog()
  }

  // 成功回调给继承的使用
  callbackSuccess() {
  }

  // 如果是弹窗打开的，关闭弹窗
  closeProductDialog() {
    const productDialogNode = this.closest('[data-product-dialog]')
    if (productDialogNode) {
      productDialogNode.parentNode.removeChild(productDialogNode)
    }
  }
}
customElements.define('le-add-cart-btn', LeAddCartBtn);

/**
 * 添加弹窗组件
 * 下面是使用方法，必须要包括下面结构，样式可以自己调
 * 
 * le-dialog-hyaline 类是弹窗一的样式
 * le-dialog 类是弹窗二的样式
 * 
 * <le-dialog>
    <div class="le-dialog__content le-dialog-hyaline">
      <div class="dialog-wrap">
        <div class="dialog--header">
          <span class="header-title">title</span>
          <span class="le_icon--close">
            <svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28">
              <use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_close"></use>
            </svg>
          </span>
        </div>
        <div class="dialog--body">
          xxx
        </div>
        <div class="dialog--footer"></div>
      </div>
    </div>
  </le-dialog>

    xxx 是自定义的内容
    title 是标题
 */
class LeDialog extends HTMLElement {
  constructor() {
    super();

    this.bindClickClose()
  }

  bindClickClose() {
    this.querySelector('.le_icon--close').addEventListener('click', (e) => {
      this.handlerClose()
    })
    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('le-dialog__content')) {
        this.handlerClose()
      }
    })
  }

  show() {
    this.querySelector('.le-dialog__content').style.display = 'block'
  }

  handlerClose() {
    this.close()
  }

  close() {
    this.querySelector('.le-dialog__content').style.display = 'none'
  }
}
customElements.define('le-dialog', LeDialog);

/**
 * 折叠组件
 * 下面是使用方法，必须要包括下面结构，样式可以自己调
 * 
 * <lepro-collapse>
    <div data-type="plain">
      标题
    </div>
    <div data-type="content">
      内容
    </div>
  </lepro-collapse>

  data-type="plain" 与 data-type="content" 是一组并且是兄弟节点

  如果有多个，用一个 标签 包裹起来就行了。比如 
  <lepro-collapse>
    <div>
        <div data-type="plain">
        标题
        </div>
        <div data-type="content">
        内容
        </div>
    </div>
    <div>
        <div data-type="plain">
        标题
        </div>
        <div data-type="content">
        内容
        </div>
    </div>
  </lepro-collapse>
 */
class LeproCollapse extends HTMLElement {
  constructor() {
    super();
    this.init()
  }

  init() {
    const plainNode = this.querySelectorAll('[data-type="plain"]')

    plainNode.forEach(node => {
      node.addEventListener('click', (event) => {
        node.classList.toggle('active')
        const parent = node.parentElement
        const contentNode = parent.querySelector('[data-type="content"]')
        if (node.classList.contains('active')) {
          contentNode.style.height = `${contentNode.scrollHeight}px`
        } else {
          contentNode.style.height = '0'
        }
      })
    })
  }
}
customElements.define('lepro-collapse', LeproCollapse);

/**
 * tab 切换 组件
 * <le-gift-card-component>
      <div class="tabs flex">
        <span class="tab-title active" data-tab-title data-index="1">Available</span>
        <span class="tab-title" data-tab-title data-index="2">Not Available</span>
      </div>
      <div class="tab-content available-content relative" data-tab-content visible data-index="1">
        <div class="earn-info flex flex-wrap">&nbsp;</div>
      </div>
      <div class="tab-content available-content relative" data-tab-content data-index="2">
        <div class="earn-info flex flex-wrap">&nbsp;</div>
      </div>
    </le-gift-card-component>
 */
class LeTabComponent extends HTMLElement {
  componentElements = this.getComponentElements()

  constructor() {
    super();
    this.init()
    this.bindEvent()
  }

  init() { }

  getComponentElements() {
    return {
      tabTitles: this.querySelectorAll('[data-tab-title]'),
      tabContents: this.querySelectorAll('[data-tab-content]'),
      tabNavBox: this.querySelector('[data-nav-box]'),
    }
  }

  bindEvent() {
    const tabTitles = this.querySelectorAll('[data-tab-title]')
    tabTitles.forEach((item) => {
      item.addEventListener('click', this._handleTabClick.bind(this))
    })
  }

  _handleTabClick(e) {
    const dataIndex = e.target.dataset.index
    const tabTitles = this.componentElements.tabTitles
    const tabContents = this.componentElements.tabContents
    tabTitles.forEach((item) => {
      if (item.dataset.index === dataIndex) {
        item.classList.add('active')
      } else {
        item.classList.remove('active')
      }
    })

    tabContents.forEach((item) => {
      if (item.dataset.index === dataIndex) {
        item.setAttribute('visible', true)
      } else {
        item.removeAttribute('visible')
      }
    })

    this.setScroll(e)

    this._handleTabClickCallback(dataIndex)
  }

  // click 回调函数，给其它继承的组件使用
  // 子类可以重写这个方法
  _handleTabClickCallback(index) { }

  // 点击自动滚动
  setScroll(e) {
    if (this.componentElements.tabNavBox) {
      const boxScrollLeft = this.componentElements.tabNavBox.scrollLeft
      const boxWidth = this.componentElements.tabNavBox.clientWidth
      const boxOffsetLeft = this.componentElements.tabNavBox.offsetLeft

      const itemWidth = e.currentTarget.clientWidth
      const itemOffsetLeft = e.currentTarget.offsetLeft - boxOffsetLeft
      if (itemWidth + itemOffsetLeft > boxScrollLeft + boxWidth || itemOffsetLeft < boxScrollLeft) {
        this.componentElements.tabNavBox.scrollLeft = itemOffsetLeft - (boxWidth / 2) + (itemWidth / 2)
      }
    }
  }
}
customElements.define('le-tab-component', LeTabComponent);

// PR 模块
class PrSection extends LeLazyTool {
  constructor() {
    super();

    this.lazyHtmls = {
      sayingSection:
        '<div class="say-nav-list" data-index="2"><div class="img-wrap"><img src="https://static.lepro.com/media/lepro/saying/say_img_2.png" alt="" class="img"></div></div>' +
        '<div class="say-nav-list" data-index="3"><div class="img-wrap"><img src="https://static.lepro.com/media/lepro/saying/say_img_3.png" alt="" class="img"></div></div>' +
        '<div class="say-nav-list" data-index="4"><div class="img-wrap"><img src="https://static.lepro.com/media/lepro/saying/say_img_4.png" alt="" class="img"></div></div>' +
        '<div class="say-nav-list" data-index="5"><div class="img-wrap"><img src="https://static.lepro.com/media/lepro/saying/say_img_5.png" alt="" class="img"></div></div>' +
        '<div class="say-nav-list" data-index="6"><div class="img-wrap"><img src="https://static.lepro.com/media/lepro/saying/say_img_6.png" alt="" class="img"></div></div>' +
        '<div class="say-nav-list" data-index="7"><div class="img-wrap"><img src="https://static.lepro.com/media/lepro/saying/say_img_7.png" alt="" class="img"></div></div>'
    }

    this.lazyNodes = null

    this.init()
  }

  addHtml(type) {
    switch (type) {
      case 'sayingSection':
        this.initSaying()
        break
      default:
        break
    }
  }

  initSaying() {
    var sayData = {
      '1': 'Best Task Lamp<br><br><strong>- Lepro LED Task Lamp</strong>',
      '2': 'Bring the grandeur of the universe into your home with this AI-powered lighting<br><br><strong>- Lepro TB1</strong>',
      '3': 'AI-generated lighting from Lepro should be setting the mood for your gaming sessions<br><br><strong>- Lepro TB1, Lepro WL1, Lepro N1, Lepro S1</strong>',
      '4': 'Lepro introduces new smart home lighting solutions trained on large language models<br><br><strong>- Lepro TB1</strong>',
      '5': 'Meet the TB1 table lamp from Lepro: an innovative take on personal lighting backed by AI<br><br><strong>- Lepro TB1</strong>',
      '6': 'The Lepro TB1 AI table lamp uses an LLM to take smart lighting to new places<br><br><strong>- Lepro TB1</strong>',
      '7': 'Lepro has some really Cool AI lighting!<br><br><strong>- AI Lighting</strong>'
    }

    var sayConDom = $('.le-saying-section')
    sayConDom.addClass('ld-scroll-load-show')
    var sayNavDom = sayConDom.find('.say-nav-list')
    var sayingTabConDom = sayConDom.find('.saying-tab-con')

    sayNavDom.hover(function () {
      var index = $(this).attr('data-index')
      $(this).addClass('active')
      $(this).siblings().removeClass('active')
      sayingTabConDom.html(sayData[index] || '')
    }, function () { })
    sayingTabConDom.html(sayData['1'] || '')
  }
}
customElements.define('pr-section', PrSection);

// 社区分享组件
class LeCommunityShare extends HTMLElement {
  constructor() {
    super();

    /**
     * this.mediaAggt = {
      ugc: [
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__ugc-1.jpg?v=1753943990' }
      ],
      say: [
          { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-1.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/88fece7070934aac89931c94667ae364.mp4' }
        ]
      }
     */
    this.mediaAggt = {}
  }
  init() {
    const _that = this
    const windowInnerWidth = $(window)[0].innerWidth
    const sliderBlockNode = $(this).find('.slider-wrap')
    const commuityShareSlick = $(this).find(".le-community-share-slider")
    $(function () {
      _that.setHtml()

      commuityShareSlick.on('init', function (event, slick) {
        sliderBlockNode.css({ height: 'initial', visibility: 'initial' })

        // 如果组件存在属性，就说明是图片视频组件，可以点击打开弹窗
        if (_that.dataset.type == 'img-video') {
          _that.bindClick()
        }
      })
      commuityShareSlick.slick({
        autoplaySpeed: 5000,
        autoplay: true,
        lazyLoad: 'ondemand',
        slidesToShow: windowInnerWidth > 990 ? 5 : windowInnerWidth > 680 ? 2 : 1,
        centerMode: true,
        initialSlide: 1,
        cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
        prevArrow:
          '<div class="arrow-icon prev-btn flex justify-center align-items-center cursor-pointer"><svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_left2"></use></svg></div>',
        nextArrow:
          '<div class="arrow-icon next-btn flex justify-center align-items-center cursor-pointer"><svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_right2"></use></svg></div>'
      })
    })
  }
  bindClick() {
    const dialogNode = $('le-dialog-hyaline')
    const slides = $(this).find('.le-community-share-box')

    slides.on('click', function () {
      const videoUrl = $(this).attr('data-video-url')

      const backgroundImage = $(this).find('.main-img-wrap').css('background-image')
      const imgUrl = backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

      dialogNode[0].initVideo(imgUrl, videoUrl)
      dialogNode[0].show()
    })
  }
  setHtml() {
    const role = this.dataset.role
    const aggtData = this.mediaAggt[role]
    if (aggtData?.length) {
      let node = ''

      aggtData.forEach(item => {
        node += `<div class="le-community-share-box" ${item.videoUrl ? `data-video-url="${item.videoUrl}"` : ''}>
          <div class="main-img-wrap" style="background-image: url(&quot;${item.imgUrl}&quot;);">
            ${item.videoUrl ? `<div class="paly-icon flex justify-center align-items-center cursor-pointer"><svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_play2"></use></svg></div>` : ''}
          </div>
        </div>`
      })

      $(this).find('.le-community-share-slider').append(node)
    }
  }
}

// 锚点滚动效果
class LeAnchorScrolling extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = null
    this.scrollTopCurrent = 0
    this.anchorDoms = []
    this.elements = this.getElements()

    this.init()
    this.handlerScroll()
    this.created()
  }

  // 初始化，继承的使用
  created() {
  }

  getElements() {
    return {
      jumpNav: this.querySelector('[data-jump-nav]'),
      contentNodes: this.querySelectorAll('[data-content]')
    }
  }

  init() {
    // 获取导航栏内的锚点
    const jumpNav = this.elements.jumpNav
    this.anchorDoms = jumpNav ? jumpNav.querySelectorAll('[data-anchor]') : []

    // 根据锚点 href 收集内容节点（用 null 占位保持索引对应）
    this.contentNodes = []
    this.anchorDoms.forEach((dom, index) => {
      const href = dom.getAttribute('href')
      const targetNode = href ? document.querySelector(href) : null
      this.contentNodes.push(targetNode) // 可能是 null
      dom.addEventListener('click', this.handlerClick.bind(this, index))
    })

    this.scrollFn()
  }

  handlerClick(index, e) {
    e.preventDefault()
    this.currentIndex = index
    const targetId = e.currentTarget.getAttribute('href')
    const targetNode = document.querySelector(targetId)

    const jumpNavNode = this.elements.jumpNav

    if (targetNode && jumpNavNode) {
      const jumpNavHeight = jumpNavNode.getBoundingClientRect().height
      const jumpNavTop = jumpNavNode.getBoundingClientRect().top
      this.scrollTopCurrent = targetNode.getBoundingClientRect().top + window.scrollY - jumpNavHeight
      // this.scrollTopCurrent = targetNode.getBoundingClientRect().top + window.scrollY

      if (this.hasVerticalScroll() && this.scrollTopCurrent >= jumpNavTop) {
        window.scrollTo({
          top: this.scrollTopCurrent,
          behavior: "smooth"
        })
      }

      this.anchorDoms.forEach(dom => {
        dom.classList.remove('active')
      })

      e.currentTarget.classList.add('active')
    }
  }

  // 是否可以滚动
  hasVerticalScroll(el = document.documentElement) {
    return el.scrollHeight > el.clientHeight
  }

  // 设置悬浮
  setFixed() {
    document.body.classList.add('le-anchor-scrolling')
  }
  // 删除悬浮
  removeFixed() {
    document.body.classList.remove('le-anchor-scrolling')
  }

  handlerScroll() {
    const _that = this
    window.addEventListener(
      "scroll",
      _that.scrollFn.bind(_that)
    )
  }

  scrollFn() {
    const jumpNavNode = this.elements.jumpNav
    if (!jumpNavNode) return

    // 如果有 null 的内容节点，尝试重新查找
    const hasNull = this.contentNodes.some(node => node === null)
    if (hasNull) {
      this.anchorDoms.forEach((dom, index) => {
        if (this.contentNodes[index] === null) {
          const href = dom.getAttribute('href')
          if (href) {
            const targetNode = document.querySelector(href)
            if (targetNode) {
              this.contentNodes[index] = targetNode
            }
          }
        }
      })
    }

    const contentNodes = this.contentNodes
    if (contentNodes.length === 0) return

    const jumpNavHeight = jumpNavNode.getBoundingClientRect().height
    const jumpNavTop = jumpNavNode.getBoundingClientRect().top + jumpNavHeight
    if (jumpNavTop > 2) {
      this.removeFixed()
    } else {
      this.setFixed()
    }

    // 找到最合适的元素：顶部已经滚过导航栏的最后一个
    let activeIndex = -1
    for (let i = 0; i < contentNodes.length; i++) {
      const contentNode = contentNodes[i]
      if (!contentNode) continue
      const rect = contentNode.getBoundingClientRect()
      if (rect.top <= jumpNavHeight + 50) {
        activeIndex = i
      }
    }

    // 如果都没滚到，选择第一个有效的
    if (activeIndex < 0) {
      for (let i = 0; i < contentNodes.length; i++) {
        if (contentNodes[i]) {
          activeIndex = i
          break
        }
      }
    }

    // 如果有 currentIndex（点击后正在滚动），优先使用它
    if (this.currentIndex != null) {
      const atEnd = Math.abs(window.scrollY - this.scrollTopCurrent) < 2
      if (atEnd) {
        activeIndex = this.currentIndex
        this.currentIndex = null
      } else {
        activeIndex = this.currentIndex
      }
    }

    if (activeIndex >= 0 && this.anchorDoms[activeIndex]) {
      this.anchorDoms.forEach(dom => {
        dom.classList.remove('active')
      })
      this.anchorDoms[activeIndex].classList.add('active')
    }
  }

  // 判断dom是否在可视区域内
  isPartiallyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom > 0
    );
  }
}
customElements.define('le-anchor-scrolling', LeAnchorScrolling);

// 详情页悬浮添加购物车
class LeproFixedAddCart extends HTMLElement {
  constructor() {
    super();

    const type = this.dataset.cutsomAddCart
    if (type === 'productDialog') {
      this.productDialogLogic()
    } else {
      this.defaultLogic()
    }
  }

  defaultLogic() {
    $(this).find('.add-cart-btn').on('click', function () {
      $(this).closest('lepro-fixed-add-cart').find('.checkout-btn').removeAttr('data-link')
      $('.product-form__buttons .product-form__submit').trigger('click')
      $(this).find('.loading__spinner').removeClass('hidden')
      $(this).attr('disabled', true)
      $(this).addClass('loading')
    })

    $(this).find('.checkout-btn').on('click', function () {
      $(this).attr('data-link', true)
      $('.product-form__buttons .product-form__submit').trigger('click')
      $(this).find('.loading__spinner').removeClass('hidden')
      $(this).attr('disabled', true)
      $(this).addClass('loading')
    })
  }

  productDialogLogic() {
  }
}
customElements.define('lepro-fixed-add-cart', LeproFixedAddCart);

class LeProductDialog extends LeDialog {
  close() {
    document.body.classList.remove('overflow-hidden')
    document.body.removeChild(this.parentNode)
  }
}
customElements.define('le-product-dialog', LeProductDialog);

// 商品详情利益点
class CollapseComponent extends HTMLElement {
  elements = this.getElements()

  constructor() {
    super();

    this.bindClick()
  }

  getElements() {
    return {
      titleNode: this.querySelectorAll('.collapse-title'),
      moreNode: this.querySelectorAll('.show-less-btn')
    }
  }

  bindClick() {
    this.elements.titleNode.forEach(item => {
      item.addEventListener('click', this.handlerTitleClick.bind(this))
    })

    this.elements.moreNode.forEach(item => {
      item.addEventListener('click', this.handlerMoreClick.bind(this))
    })
  }

  handlerTitleClick(e) {
    if (e.currentTarget.getAttribute('disabled')) return

    const parentNode = e.currentTarget.parentElement
    if (parentNode.classList.contains('collapse-checked')) {
      parentNode.classList.remove('collapse-checked')
    } else {
      parentNode.classList.add('collapse-checked')
    }
  }

  handlerMoreClick(e) {
    const parentNode = e.currentTarget.closest('.le-collapse-description')
    const textNode = e.currentTarget.querySelector('.text')
    let text = 'Show More'
    if (parentNode.classList.contains('checked')) {
      parentNode.classList.remove('checked')
      text = 'Show More'
    } else {
      parentNode.classList.add('checked')
      text = 'Show Less'
    }

    if (textNode) {
      textNode.textContent = text
    }
  }
}
customElements.define('collapse-component', CollapseComponent);